import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List,
  API_SALESFORCE,

  gAPI_Ingetration,
} from '../../../../../constants/APIs';

import {
  dAPI_Delete_Ingetration,
  API_CloudBeds,
} from '../../../../../constants/APIs';
import { Changecloudbeds } from '../../../../../redux/actions';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { setIn } from 'formik';
import Validation from '../../../../../components/Validation';

let arr = [];
function CloudsBedsIntegration({ visible, toggle, id, LoadIntegrations }) {
  const [property, setProperty] = useState([]);
  const [maskData, setMaskData] = useState({
    clientId: '',
    clientSecretKey: '',
  });
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    clientId: process.env.REACT_APP_CLOUDBEDS_CLIENT_ID,
    clientSecretKey: process.env.REACT_APP_CLOUDBEDS_CLIENT_SECRET_KEY,
    domainName: '',
    redirectUrl: '',
    cancelReservation: false,
    sendCancellationEmail: false
  });
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_CloudBeds}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            clientId: (res.data.cloudBedsIntegration.clientId),
            clientSecretKey: (res.data.cloudBedsIntegration.clientSecretKey),
            redirectUrl: (res.data.cloudBedsIntegration.redirectUrl),
            hotelId: (res.data.cloudBedsIntegration.hotelId),
            refreshToken: (res.data.cloudBedsIntegration.refreshToken),
            accessToken: (res.data.cloudBedsIntegration.accessToken),
            cancelReservation: res.data.cloudBedsIntegration.cancelReservation,
            sendCancellationEmail: res.data.cloudBedsIntegration.sendCancellationEmail
          });

          setMaskData({
            ...maskData,
            clientId: mask(res.data.cloudBedsIntegration.clientId),
            clientSecretKey: mask(res.data.cloudBedsIntegration.clientSecretKey),
          });
        });
      // .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleClientKeyChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, clientId: mask(e.target.value) });
    setInputData({ ...inputData, clientId: e.target.value });
    //
  };
  const handleClientSecretChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, clientSecretKey: mask(e.target.value) });
    setInputData({ ...inputData, clientSecretKey: e.target.value });
    //
  };
  const handleDomainName = (e) => {
    e.persist();
    setInputData({ ...inputData, domainName: e.target.value });
    ;
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleCheckSettingsChange = (e) => {    
      setInputData({ ...inputData, [e.target.name]: e.target.checked });   
  };

  const handleSave = async () => {
    if (inputData.clientId !== "" && inputData.clientSecretKey !== "") {
      if (id !== undefined) {
        AxiosAPI({
          method: 'put',
          url: `${API_CloudBeds}/${id}?group_id=${getGroupID()}`,
          data: inputData,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            toggle();
            setTimeout(() => {
              LoadIntegrations();
            }, 300);
          }
        });
      } else {
        AxiosAPI({
          method: 'post',
          url: API_CloudBeds,
          data: inputData,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            toggle();
            Changecloudbeds(res.data.id);
            setTimeout(() => {
              window.location.href = `https://hotels.cloudbeds.com/api/v1.1/oauth?client_id=${inputData.clientId}&redirect_uri=${process.env.REACT_APP_CLOUDBEDS_REDIRECT_URL}&response_type=code&scope=read%3AcustomFields+write%3AcustomFields+read%3Apayment+write%3Apayment+read%3Areservation+write%3Areservation+read%3Ahotel`;
            }, 300);
          }
        });        
      }
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"} Intregation</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <CustomInput
                      className="itemCheck mb-0"
                      type="checkbox"
                      id={`check_cancelReservation`}
                      name="cancelReservation"
                      checked={inputData.cancelReservation}
                      onChange={handleCheckSettingsChange}
                      label="Cancel reservation if aiva voucher is not valid"
                    />
                  </FormGroup>
                   <FormGroup className="mb-2">
                    <CustomInput
                      className="itemCheck mb-0"
                      type="checkbox"
                      id={`check_sendCancellationEmail`}
                      checked={inputData.sendCancellationEmail}
                      name="sendCancellationEmail"
                      onChange={handleCheckSettingsChange}
                      label="Send cancellation email to customer"
                    />
                  </FormGroup>
                  <FormGroup className="mt-3">
                    <div className='integration-property text-start'>
                      <div className='row'>
                        {property.map((p, index) => {
                          return (
                            <div className='col-md-6'>
                              <CustomInput
                                key={p.id}
                                type="radio"
                                id={index}
                                label={p.name}
                                value={p.id}
                                name="property"
                                checked={
                                  p.id === inputData.Properties[0] ? true : false
                                }
                                onChange={handleCheckChange}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Intregation
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Intregation
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ }) => {

};

export default injectIntl(connect(mapStateToProps, { Changecloudbeds })(CloudsBedsIntegration));

